import {load} from '@shopify/theme-sections'
import Cookies from 'js-cookie'
import '../../styles/templates/page.scss'

import '../sections/index-accordion'

import '../sections/index-contact'
import '../sections/index-content-grid'
import '../sections/index-content-image-grid'
import '../sections/index-counter'
import '../sections/index-feature-block'
import '../sections/index-feature-contact'
import '../sections/index-feature-cta'
import '../sections/index-featured-products'
import '../sections/index-hero-category'
import '../sections/index-hero-cta'
import '../sections/index-hero-image'
import '../sections/index-hero-slider'
import '../sections/index-icons-links'
import '../sections/index-image-content'
import '../sections/index-image-content-row'
import '../sections/index-key-features'
import '../sections/index-product-carousel'
import '../sections/index-reviews'
import '../sections/section-content-cards'
import '../sections/section-cta-content-card'
import '../sections/section-border-content'
import '../sections/contact-us-grid'
import '../sections/section-custom-locations'
import '../sections/section-brands'
import '../sections/section-process-dropdown'
import '../sections/section-tabbed-calculator'
import '../sections/section-flexible-table-content'
import '../sections/section-flexible-accordion-content'
import '../sections/section-flexible-video'

import '../sections/section-calculator-v2'
import '../sections/section-six-tiles'
import '../sections/section-testimonial-v2'
import '../sections/section-center-text'
import '../sections/section-center-text-AS'
import '../sections/section-accordion-two-columns-v2'
import '../sections/section-enquire-form-v2'
import '../sections/section-review-star'
import '../sections/section-four-grids'
import '../sections/section-icon-carousel'
import '../sections/section-icon-3-cols'
import '../sections/section-three-card-blogs'
import '../sections/section-2-price-card'
import '../sections/section-two-col-complex'
import '../sections/section-heading-text'
import '../sections/section-4-col-tiles'
import '../sections/section-compare-table'
import '../sections/section-custom-collection-list'
import '../sections/section-table-with-text'
import '../sections/section-tax-disclaimer'
import '../sections/section-accordion-right'
import '../sections/section-multi-column-content'
import '../sections/section-internal-navigation-grid'
import '../sections/section-headshots'
import '../sections/section-business-location'
import '../sections/custom-images'
import '../sections/section-icon-6-col'
import '../sections/section-border-content-module'
import '../sections/section-quote-card'
import '../sections/section-three-column'
import '../sections/section-steps'
import '../sections/center-content-module'
import '../sections/section-two-column-embed'
import '../sections/section-delivery-table'
import '../sections/section-img-text'

load([
    `index-hero-image`,
    `index-hero-slider`,
    `index-hero-cta`,
    `index-image-content`,
    `index-icons-links`,
    `index-hero-category`,
    `index-contact`,
    `index-product-carousel`,
    `index-content-grid`,
    `index-counter`,
    `index-content-image-grid`,
    `index-articles`,
    `feature-content`,
    `index-feature-block`,
    `index-feature-cta`,
    `index-image-content-row`,
    `index-reviews`,
    `index-articles-row`,
    `index-key-features`,
    `index-featured-products`,
    `index-accordion`,
    `section-process-dropdown`,
    `section-accordion-two-columns-v2`,
    `section-testimonial-v2`,
    `section-icon-carousel`,
    `section-icon-3-cols`,
    `section-three-card-blogs`,
    `section-two-col-complex`,
    `section-compare-table`,
    `section-custom-collection-list`,
    `section-table-with-text`,
    `section-tax-disclaimer`,
    `section-accordion-right`,
    `section-internal-navigation-grid`,
    `section-headshots`,
    `section-border-content`,
    `section-business-location`,
    `contact-us-grid`,
    `section-custom-locations`,
    `custom-images`,
    `section-icon-6-col`,
    `section-brands`,
    `section-border-content-module`,
    `section-quote-card`,
    `section-three-column`,
    `section-steps`,
    `center-content-module`,
    `section-two-column-embed`,
    `section-tabbed-calculator`,
    `section-delivery-table`,
    `section-flexible-table-content`,
    `section-flexible-accordion-content`,
    `section-flexible-video`,
])  

if (Cookies.get(`_redirect`) && Cookies.get(`_redirect`) != 0) {
    window.location = Cookies.get(`_redirect`)
    Cookies.set(`_redirect`, `0`)
} else {
    document.querySelector(`html`).classList.remove(`hide`)
}
